import { createEffect } from "solid-js";
import { createRoute, useNavigate, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { usePowerSyncContext } from "@/providers/power-sync-context";
import { useDrizzle } from "@/hooks/use-drizzle";
import { createPowerSyncSingle } from "@listto/shared/solid";
import { getTodoDetailQuery, queryKeys } from "@listto/shared";
import { FullPageLoader } from "@/components/full-page-loader";

function LegacyTodoRedirectPage() {
  const params = useParams({ from: "/_app/todo/$todoId" });
  const navigate = useNavigate();
  const { db } = usePowerSyncContext();
  const drizzle = useDrizzle();

  const todoQuery = createPowerSyncSingle({
    queryKey: () => queryKeys.todos.detailRedirect(params().todoId),
    db: () => db(),
    queryFn: () => {
      const dbInstance = drizzle();
      return dbInstance ? getTodoDetailQuery(dbInstance, params().todoId) : null;
    },
    enabled: () => Boolean(params().todoId) && Boolean(drizzle()),
  });

  createEffect(() => {
    const todo = todoQuery.data;
    if (todo) {
      if (todo.list_id) {
        void navigate({
          to: "/lists/$listId/todo/$todoId",
          params: { listId: todo.list_id, todoId: todo.id },
          replace: true,
        });
      } else {
        void navigate({
          to: "/inbox/todo/$todoId",
          params: { todoId: todo.id },
          replace: true,
        });
      }
    } else if (!todoQuery.isLoading && !todoQuery.error) {
      // Fallback to home if task not found
      void navigate({ to: "/", replace: true });
    }
  });

  return <FullPageLoader />;
}

export const globalTodoRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/todo/$todoId",
  component: LegacyTodoRedirectPage,
});
